import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Container,
  Row,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  Button,
} from "reactstrap";

import Breadcrumbs from "../../../components/common/Breadcrumb";

import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";

import { AxiosResponse } from "axios";
import { ApiCore } from "../../../helpers/api_helper";
import { Endpoints } from "../../../utils/Endpoints";
import { amountToCurrency, formattedDate } from "../../../utils/Helpers";
import { Link, useHistory, useLocation } from "react-router-dom";
import SearchReport from "./search";
import { invoiceEndDate, invoiceStartDate } from "../../../utils/Helpers";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const IncomeStatement = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [expenses, setExpenses] = useState<any>([]);
  const [revenues, setRevenues] = useState<any>([]);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const params = new URLSearchParams(useLocation().search);

  const history = useHistory();

  const handleEdit = async (id: string) => {
    //history.push("/transactions/sales/new?id="+id);
  };

  const rowEvents = {
    onClick: (e: any, invoice: any) => {
      history.push("/invoices-detail/" + invoice.id);
    },
  };

  const searchIncomeStatement = (values: any) => {
    if ((values.pdf && values.pdf == 1) || (values.excel && values.excel == 1)) {
      fetchFile(values)
    } else {
      fetchHtml(values)
    }
  };

  const fetchFile = (values: any) => {
    const type = (values.excel && values.excel == 1) ? "excel" : "pdf"

    toast
      .promise(request
        .get(Endpoints.incomestatement, { params: { sdate: values.sdate, edate: values.edate, type: type } }, "arraybuffer"), {
        pending: "Please wait..",
        success: {
          render({ data }) {
            return "";
          },
        },
        error: {
          render({ data }) {
            return data;
          },
        },
      })
      .then((response: AxiosResponse) => {
        const type = response.headers['content-type']
        const blob = new Blob([response.data], { type: type })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = (values.excel && values.excel == 1) ? `IncomeStatement-${+ new Date()}.xlsx` : `IncomeStatement-${+ new Date()}.pdf`
        link.click()
      });
  }

  const fetchHtml = (values: any) => {
    toast
      .promise(request.get(Endpoints.incomestatement, { params: { sdate: values.sdate, edate: values.edate } }), {
        pending: "Please wait..",
        success: {
          render({ data }) {
            return "";
          },
        },
        error: {
          render({ data }) {
            return data;
          },
        },
      })
      .then((response: AxiosResponse) => {
        const { revenues, expenses, totalRecords } = response.data;
        setRevenues(revenues);
        setExpenses(expenses);
        setTotalRecords(totalRecords);
        setLoading(false);
      })
      .catch(error => {
        console.error(error);
      });
  }

  const request = new ApiCore();

  const pageOptions = {
    sizePerPage: 25,
    totalSize: totalRecords, // replace later with size(users),
    custom: true,
  };

  const computeAmounts = (item: any): number => {
    let totalAmount = 0;

    for (let i = 0; i < item.length; i++) {
      totalAmount += item[i].dr;
    }
    return totalAmount; 
  }

  const computeTotals = (item: any) => {
    let totalAmount = 0;

    for (let i = 0; i < item.length; i++) {
      totalAmount += item[i].dr;
    }
    return amountToCurrency(totalAmount); 
  }

  const calcNetIncome = (item1: any, item2: any) => {
    item1 = computeAmounts(item1);
    item2 = computeAmounts(item2);
    return  amountToCurrency(item1 - item2);
  }

  const determineText = (): any => {
    if ((computeAmounts(revenues) - computeAmounts(expenses)) >= 0) {
      return "Net Income"
    } else {
      return "Net Loss"
    }
  }

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="page-content">
        <MetaTags>
          <title>Income Statement | Treda - React Admin & Dashboard Template</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Reports" breadcrumbItem="Income" />
          <Row>
            <Col lg="12">
              <Card>
                <CardHeader className="justify-content-between d-flex align-items-center">
                  <CardTitle className="h4">Income Statement</CardTitle>

                  <UncontrolledDropdown className="mt-4 mt-sm-0">
                    <DropdownToggle tag="a" className="btn btn-light">
                      <i className="fa fa-ellipsis-v"></i>
                    </DropdownToggle>
                  </UncontrolledDropdown>
                </CardHeader>

                <CardBody>
                  <Row>
                    <Col xl="12">
                      <SearchReport
                        sdate={invoiceStartDate()}
                        edate={invoiceEndDate()}
                        handleSearch={(values: any) => {
                          searchIncomeStatement(values);
                        }}
                      />
                    </Col>
                  </Row>
                  <table className="table">
                    <tbody>
                      <tr>
                        <th colSpan={2}><b>Revenues & Gains</b></th>
                      </tr>
                      {revenues && revenues.map((item: any) => {
                        return (<>
                          <tr key={item.id}>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{item.name}</td>
                            <td className="text-center">{amountToCurrency(item.dr)}</td>
                          </tr>
                        </>)
                      })}

                      <tr>
                        <td><b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Total revenue & Gain</b></td>
                        <td className="text-center"><b>{computeTotals(revenues)}</b></td>
                      </tr>

                      <tr>
                        <th colSpan={2}><b>Expenses & Losses</b></th>
                      </tr>
                      {expenses && expenses.map((item: any) => {
                        return (<>
                          <tr key={item.id}>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{item.name}</td>
                            <td className="text-center">{amountToCurrency(item.dr)}</td>
                          </tr>

                        </>)
                      })}
                      <tr>
                        <td><b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Total expenses & losses</b></td>
                        <td className="text-center"><b>{computeTotals(expenses)}</b></td>
                      </tr>
                      <tr>
                        <td><b>{determineText()}</b></td>
                        <td className="text-center"><b>{calcNetIncome(revenues, expenses)}</b></td>
                      </tr>
                    </tbody>
                  </table>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default IncomeStatement;
